// Third-party packages
import {
  Button,
  Container,
  Icon,
  Grid,
  Segment,
} from 'semantic-ui-react'

const SectionFooter = () => {
  return (
    <Segment inverted vertical style={{ padding: '5em 0em' }}>
      <Container>
        <Grid inverted stackable>
          <Grid.Row>
            <Grid.Column width={8}>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  )
}

export default SectionFooter
